<div class="w-100">
      <h5>Add recipients</h5>
      <form
        [formGroup]="recipientForm"
        (ngSubmit)="addRecipient()"
        id="recipient-form"
      >
        <div class="input-item">
          <label for="recipientName">Recipient Name</label>
          <input
            placeholder="Enter recipient name"
            type="text"
            formControlName="recipientName"
            id="recipientName"
          />
        </div>
        <div class="input-item">
          <label for="customerId">Customer ID</label>
          <input
            placeholder="Enter customer ID"
            type="text"
            formControlName="customerId"
            id="customerId"
          />
        </div>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!recipientForm.valid"
        >
          Submit
        </button>
      </form>
    </div>
    <p-table
      [value]="recipients"
      styleClass="p-datatable-gridlines"
      [tableStyle]="{
        width: '100%',
      }"
      editMode="row"
      dataKey="id"
    >
      <ng-template pTemplate="header">
        <tr [pEditableRow]="recipient">
          <th>Recipient</th>
          <th>Customer Id</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-recipient
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="recipient">
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="recipient.recipientName"
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ recipient.recipientName }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="recipient.customerId"
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ recipient.customerId }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <div class="flex align-items-center justify-content-center gap-2">
              <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                (click)="editRecipientInit(recipient)"
                class="p-button-rounded p-button-text"
              ></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                (click)="editRecipientSave(recipient)"
                class="p-button-rounded p-button-text p-button-success mr-2"
              ></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                (click)="editRecipientCancel(recipient, ri)"
                class="p-button-rounded p-button-text p-button-danger"
              ></button>
            </div>
          </td>
          <td>
            <i
              class="bi bi-trash-fill remove-block-icon"
              (click)="deleteRecipient(recipient)"
            ></i>
          </td>
        </tr>
      </ng-template>
    </p-table>